// extracted by mini-css-extract-plugin
export var backgroundImage = "SupplyFocusHeroSection-module--backgroundImage--6dd80";
export var content = "SupplyFocusHeroSection-module--content--69d66";
export var cta = "SupplyFocusHeroSection-module--cta--c4a3b";
export var info = "SupplyFocusHeroSection-module--info--e0f8e";
export var logo = "SupplyFocusHeroSection-module--logo--c7f82";
export var title = "SupplyFocusHeroSection-module--title--2257a";
export var wrapper = "SupplyFocusHeroSection-module--wrapper--f9f40";